export const environment = {
  production: true,
  apiUrl: 'https://hhi-admin-api.beam.live/api/v1',
  gpsApiUrl: 'https://hhi-gps.beam.live/api/v1',
  socketUrl: 'https://hhi-admin-api.beam.live',
  staticAssetUrl: 'https://hhi-admin-api.beam.live/api'
};

